import { createReducer, on } from '@ngrx/store';
import * as headerAction from './header.action'
export const initialState = {
    title: '',
  };

export const headerReducer = createReducer(
  initialState,
  on(headerAction.updateHeaderTitle, (state, { title }) =>  ({ ...state, title})),
);
